export const getCookie = (name)=> {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return decodeURIComponent(parts.pop().split(';').shift());
}

export const deleteCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

export const setCookie = (name, value, hours = 1) => {
  let expires = "";
  hours = 12
  if (hours) {
    const d = new Date();
    d.setTime(d.getTime() + (hours * 30 * 60 * 1000)); // 1 jam = 60 menit * 60 detik * 1000 ms
    expires = "; expires=" + d.toUTCString();
  }
  document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/`;
};
